import { MOS_MAX_VAL, MOS_MIN_VAL, SCORE_PRECISION } from './constants';

export function findStatsBySsrc<T extends { ssrc: number }>(ssrc: number, statsItems: T[]): T | undefined {
  return statsItems.find((remote) => remote.ssrc === ssrc);
}

export function clamp(value: number, min: number, max: number): number {
  return Math.max(min, Math.min(value, max));
}

export function toPrecision(num: number, precision = SCORE_PRECISION): number {
  return Number(num.toFixed(precision));
}

export function prepareScore(score: number): number {
  return clamp(toPrecision(score), MOS_MIN_VAL, MOS_MAX_VAL);
}

export function linearPercentile(sorted: number[], percentile: number): number {
  if (sorted.length === 0) {
    throw new Error('Cannot compute percentile of empty array');
  }

  if (sorted.length === 1) {
    return sorted[0];
  }

  const i = percentile * (sorted.length - 1);
  const lo = Math.floor(i);
  const hi = Math.ceil(i);
  const fraction = i - lo;
  const interpolatedPercentile = sorted[lo] + fraction * (sorted[hi] - sorted[lo]);

  return toPrecision(interpolatedPercentile);
}
